import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=5dbc5063&scoped=true&"
import script from "./Copyright.vue?vue&type=script&lang=ts&"
export * from "./Copyright.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc5063",
  null
  
)

export default component.exports